export const routes = {
  redirect: '/',
  home: '/entrar',
  recovery: '/recuperar',
  createNewPassword: '/recuperar/:token/:email',
  confirmRecovery: '/confirmacao',
  dashboard: '/painel',
  locals: '/locais',
  taskList: '/pedidos',
  taskDetails: '/pedidos/:taskId',
  manageUser: '/user/:id',
};
